// extracted by mini-css-extract-plugin
module.exports = {"NavWrapper":"Navigator_NavWrapper__1KJxr","AnchorCont":"Navigator_AnchorCont__mn2t_","White":"Navigator_White__37W1-","Black":"Navigator_Black__QeCsJ"};